import { SocialLinkInterface, UserSocialLinkTypeEnum } from '../../..';

export class UserSocialLinkDto implements SocialLinkInterface {
  type: UserSocialLinkTypeEnum;
  url: string;
}
